// third-party
// import { FormattedMessage } from 'react-intl';

// assets
import {
    IconKey
} from '@tabler/icons';

import StadiumIcon from '@mui/icons-material/Stadium';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ScreenshotMonitorIcon from '@mui/icons-material/ScreenshotMonitor';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ContactsIcon from '@mui/icons-material/Contacts';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import AppSettingsAltOutlinedIcon from '@mui/icons-material/AppSettingsAltOutlined';

const Pages = {
    id: 'menus',
    icon: IconKey,
    type: 'group',
    children: [
        {
            id: 'dashboard',
            // title: <FormattedMessage id="dashboard" />,
            title: 'Dashboard',
            icon: DashboardIcon,
            type: 'item',
            url: '/dashboard'
        },
        {
            id: 'venue-dashboard',
            // title: <FormattedMessage id="Venue Dashboard" />,
            title: 'Venue',
            icon: StadiumIcon,
            type: 'item',
            url: '/venue'
        },
        {
            id: 'board',
            // title: <FormattedMessage id="Board Installation" />,
            title: 'Board Installation',
            icon: ScreenshotMonitorIcon,
            type: 'item',
            url: '/board'
        },
        {
            id: 'bookings',
            // title: <FormattedMessage id="Board Installation" />,
            title: 'Bookings',
            icon: NoteAltIcon,
            type: 'item',
            url: '/bookings'
        },
        {
            id: 'transaction',
            // title: <FormattedMessage id="Transaction" />,
            title: 'Razorpay Transaction',
            icon: ReceiptLongIcon,
            type: 'item',
            url: '/transaction'
        },
        {
            id: 'users',
            // title: <FormattedMessage id="User" />,
            title: 'Users',
            icon: ContactsIcon,
            type: 'item',
            url: '/user'
        },
        {
            id: 'app-settings',
            // title: <FormattedMessage id="User" />,
            title: 'App Settings',
            icon: AppSettingsAltOutlinedIcon,
            type: 'item',
            url: '/app-settings'
        }
    ]
};

export default Pages;
